import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const MicroDateInputContext = /*#__PURE__*/createContext(undefined);
export const MicroDateInputProvider = ({
  microInputStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    microInputStyleOverrides
  }), [microInputStyleOverrides]);
  return /*#__PURE__*/_jsx(MicroDateInputContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `MicroDateInput` component.
 * Note: The context is only available when the `MicroDateInput` component is rendered as an ancestor.
 * @returns MicroDateInputContext - The context for the `MicroDateInput` component.
 * @returns MicroDateInputContext.microInputStyleOverrides - Style overrides to be applied to the `DialogButton` component.
 */
export const useMicroDateInputContext = () => {
  const microDateInputContext = useContext(MicroDateInputContext);
  return microDateInputContext;
};